import React, {useState, useRef} from "react";
import ExpandableInputGroup from "./ExpandableInputGroup";
import LinedInput, {InputType} from "./LinedInput";

export default function DemoInputGroup2() {
    const [groupExpanded, setGroupExpanded] = useState(false);
    const [street, setStreet] = useState("");
    const [street2, setStreet2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const inputRefStreet = useRef<HTMLInputElement>(null);
    const inputRefStreet2 = useRef<HTMLInputElement>(null);
    const inputRefCity = useRef<HTMLInputElement>(null);
    const inputRefState = useRef<HTMLInputElement>(null);
    const inputRefZip = useRef<HTMLInputElement>(null);

    return (
        <ExpandableInputGroup
            isExpanded={groupExpanded}
            isValid={
                !!inputRefStreet.current?.validity.valid &&
                !!inputRefCity.current?.validity.valid &&
                !!inputRefState.current?.validity.valid &&
                !!inputRefZip.current?.validity.valid
            }
            name="Address"
            setIsExpanded={setGroupExpanded}
            value={street2 ? `${street} ${street2}` : street}
            valueLine2={`${city}, ${state} ${zip}`}
        >
            {(inputProps) => (
                <>
                    <LinedInput
                        {...inputProps}
                        ref={inputRefStreet}
                        id="group-street"
                        type={InputType.Text}
                        value={street}
                        setValue={setStreet}
                        label="Street"
                        required={true}
                    />
                    <LinedInput
                        {...inputProps}
                        ref={inputRefStreet2}
                        id="group-street-2"
                        type={InputType.Text}
                        value={street2}
                        setValue={setStreet2}
                        label="Apt / unit"
                    />
                    <LinedInput
                        {...inputProps}
                        ref={inputRefCity}
                        id="group-city"
                        type={InputType.Text}
                        value={city}
                        setValue={setCity}
                        label="City"
                        required={true}
                    />
                    <LinedInput
                        {...inputProps}
                        ref={inputRefState}
                        id="group-state"
                        type={InputType.Text}
                        value={state}
                        setValue={setState}
                        label="State"
                        required={true}
                    />
                    <LinedInput
                        {...inputProps}
                        ref={inputRefZip}
                        id="group-zip"
                        type={InputType.Text}
                        value={zip}
                        setValue={setZip}
                        label="Zip Code"
                        required={true}
                    />
                </>
            )}
        </ExpandableInputGroup>
    );
}
